module.exports = __webpack_public_path__ + "static/media/2.5da13715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/2.jpg
// module id = 228
// module chunks = 0